import { Injectable } from '@angular/core'; 
import { AppInsights } from 'applicationinsights-js';
import { environment } from '../../environment/environment';

@Injectable() 
export class ApplicationInsightsLogger { 

    private config: Microsoft.ApplicationInsights.IConfig = { 
        instrumentationKey: environment.applicationInsights.instrumentationKey 
    }; 

    constructor() { 
        if (!AppInsights.config) { 
            AppInsights.downloadAndSetup(this.config); 
        } 
    } 

    logPageView(name?: string, url?: string, properties?: any, 
        measurements?: any, duration?: number) { 
        AppInsights.trackPageView(name, url, properties, measurements, duration); 
    } 

    logEvent(name: string, properties?: any, measurements?: any) { 
        AppInsights.trackEvent(name, properties, measurements); 
    } 

    logException(
        exception: Error,
        handledAt?: string,
        properties?: { [name: string]: string },
        measurements?: { [name: string]: number },
        severityLevel?: AI.SeverityLevel){
        AppInsights.trackException(exception, handledAt, properties, measurements, severityLevel);
    }
} 


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/applicationinsights-logger.ts